module.exports = __webpack_public_path__ + "img/16ff541.jpg";